import React, { useState, useRef, useEffect } from "react";
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import { useForm } from "react-hook-form";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { getTrans as t } from "../Localization/translations";
import AddSupportService from "../services/SupportTicket/CreateSupportticketService";
import { ToastContainer, toast } from "react-toastify";

export default function SupportTicket() {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [type, setType] = useState("Customer Support");
  const [viewticket, setViewticket] = useState("CreateTicket")
  const [createsupport, setCreatesupport] = useState(false);
  const [viewsupport, setViewSupport] = useState(false);

  useEffect(() => {
    viewticket === "CreateTicket"
      ? setCreatesupport(true)
      : setCreatesupport(false);
    viewticket === "ViewTicket" ? setViewSupport(true) : setViewSupport(false);

  }, [viewticket]);
  const handelOnChange = (e) => {
    setViewticket(e.target.value)
  }
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const form = useRef();

  const handleRegister = () => {
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddSupportService.addSupport(
        subject,
        body,
        type

      ).then((response) => {
        if (response.data.success) {
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {

            window.location.reload()
          }, 2000)
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
    }
  };


  const Email = {
    send: function (a) {
      return new Promise(function (resolve, reject) {
        a.nocache = Math.floor(1e6 * Math.random() + 1);
        a.Action = "Send";
        var t = JSON.stringify(a);
        Email.ajaxPost(
          "https://smtpjs.com/v3/smtpjs.aspx?",
          t,
          function (response) {
            resolve(response);
          }
        );
      });
    },
    ajaxPost: function (e, n, t) {
      var a = Email.createCORSRequest("POST", e);
      a.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      a.onload = function () {
        var response = a.responseText;
        if (t) t(response);
      };
      a.send(n);
    },
    ajax: function (e, n) {
      var t = Email.createCORSRequest("GET", e);
      t.onload = function () {
        var response = t.responseText;
        if (n) n(response);
      };
      t.send();
    },
    createCORSRequest: function (e, n) {
      var t = new XMLHttpRequest();
      t.open(e, n, true);
      return t;
    },
  };
  return (
    <div className="container-fluid mt-4">
      <ToastContainer />
      <div className="card">
        <div className="card-body">
          <h3 className="tc text-center mt-2 mb-2">Support Ticket</h3>
          <div className="mt-4 mb-3">
            <a href="https://athenafintech-help.freshdesk.com/support/home" target="_blank"
              rel="noreferrer">
              <button
                className={viewticket === "ViewTicket" ? 'btn btn-primary active ms-auto mb-0' : 'btn btn-primary  ms-auto mb-0'}
                value="ViewTicket"
                onClick={handelOnChange}
                style={{
                  borderRadius: "0rem",
                  borderBottomLeftRadius: "1.5rem",
                  borderTopLeftRadius: "1.5rem"
                }}>View Ticket </button> </a>
            <button
              value="CreateTicket"
              className={viewticket === "CreateTicket" ? 'btn btn-primary active ms-auto mb-0' : 'btn btn-primary  ms-auto mb-0'}
              onClick={handelOnChange}
              style={{
                borderRadius: " 3.5rem",
                borderBottomLeftRadius: "0rem",
                borderTopLeftRadius: "0rem"
              }}
            >Create Ticket</button>
          </div>
          {
            createsupport &&
            <Form
              role="form text-left"
              onSubmit={handleSubmit(handleRegister)}
              ref={form}
              action="."
              method="POST"
              id="addPartyContactForm"
            >
              {
                <>
                  <div className="form-group row">
                    <div className="col-md-3">
                      <label className="col-form-label required">
                        {t("Subject")}{" "}
                        <Tooltip content={t("Subject_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <input
                        placeholder={t("Subject")}
                        className="form-control"
                        type="text"
                        value={subject}
                        name="subject"
                        maxLength="200"
                        id="id_customer_name"
                        {...register("subject", {
                          onChange: (e) => {
                            setSubject(e.target.value);
                          },
                          required: true,
                        })}
                      />
                      <div className="invalid-feedback">
                        {errors.subject?.type === "required" &&
                          "Subject is required"}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3 mb-4">
                    <label className="col-form-label required">
                      {t("Details")}{" "}
                      <Tooltip content={t("Message_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <textarea
                      placeholder={t("Details")}
                      className="textareaticket"
                      type="text"
                      rows="4"
                      cols='35'
                      value={body}
                      name="message"
                      id='exampleFormControlTextarea1'
                      {...register("message", {
                        onChange: (e) => {
                          setBody(e.target.value);
                        },
                        required: true,
                      })}
                    />
                    <div className="invalid-feedback">
                      {errors.message?.type === "required" &&
                        "Message  is required"}
                    </div>
                  </div>
                  <div className="col-xl-3 mb-3">
                    <label className="col-lg-6 col-form-label text-left required">
                      {t("TypeSupport")}{" "}
                      <Tooltip content={t("Typesupport_Tooltip")}>
                        <i className="fa fa-light fa-circle-info"></i>
                      </Tooltip>
                    </label>
                    <select
                      id="Support"
                      className="form-control"
                      name="type"
                      value={type}
                      {...register("type", {
                        onChange: (e) => {
                          setType(e.target.value);
                        },
                        required: true,
                      })}
                    >
                      <option value="">{t("Select Support")}</option>
                     
                      <option value="Customer Support">{t("Customer Support")}</option>
                    </select>
                    <div className="invalid-feedback">
                      {errors.type && "Frequency is required"}
                    </div>
                  </div>
                  <button className="btn btn-primary"> send</button>
                </>
              }
              <CheckButton style={{ display: "none" }} ref={checkBtn} />
            </Form>
          }

        </div>
      </div>

    </div>
  );
}
